import { useCallback } from 'react';

import { useModal } from '@providers/ModalProvider';

export const useUnauthorizedModal = () => {
  const { showUnauthorizedModal } = useModal();

  const openUnauthorizedModal = useCallback(
    (onConfirm?: () => void) => {
      showUnauthorizedModal(onConfirm);
    },
    [showUnauthorizedModal],
  );

  return {
    openUnauthorizedModal,
  };
};
